import { ReactPlugin as AppInsightsReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

declare global {
  interface Window {
    appConfig: {
      applicationInsights: {
        instrumentationKey?: string;
      };
    };
  }
}

export const initAppInsights = () => {
  const appInsightPlugin = new AppInsightsReactPlugin();

  const appInsights = new ApplicationInsights({
    config: {
      enableAutoRouteTracking: false,
      disableFetchTracking: false,
      extensions: [appInsightPlugin as any],
      instrumentationKey:
        window.appConfig.applicationInsights.instrumentationKey
    }
  });
  appInsights.loadAppInsights();
  return appInsightPlugin;
};
